// Generieke veld-wrapper met label en optionele hint. Gedeeld tussen
// blok-eigenschappen en scenario-meta zodat de stijl consistent blijft.

import type { ReactNode } from "react";

interface Props {
  label: ReactNode;
  hint?: string;
  children: ReactNode;
}

export function Field({ label, hint, children }: Props) {
  return (
    <div className="mb-3">
      <label className="block text-xs font-medium mb-1">{label}</label>
      {children}
      {hint && <p className="text-xs text-muted-foreground mt-1">{hint}</p>}
    </div>
  );
}
